import { useState } from 'react';
import axios from 'axios';
import CONFIG from '../../constanta/config';
import Cookies from 'js-cookie';

export default function SurveyFormDay3(props) {
  const [answers, setAnswers] = useState({});
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [msgerror, setMsgerror] = useState('');


  const validate = () => {
    let newErrors = {};
    let firstErrorId = null; // 🔥 simpan error pertama

    questions.forEach((q) => {
      // RADIO / TEXTAREA / RATING
      if (q.type === "radio" || q.type === "textarea" || q.type === "rating") {
        if (!answers[q.id]) {
          newErrors[q.id] = true;

          if (!firstErrorId) {
            firstErrorId = q.id;
          }
        }
      }

      // MATRIX
      if (q.type === "rating-matrix") {
        q.items.forEach((item) => {
          if (!answers[item.id]) {
            newErrors[item.id] = true;

            if (!firstErrorId) {
              firstErrorId = item.id; // 🔥 ambil item pertama yg error
            }
          }
        });
      }
    });

    setErrors(newErrors);

    // 🚀 SCROLL KE ERROR PERTAMA
    if (firstErrorId) {
      setTimeout(() => {
        const el = document.getElementById(`question-${firstErrorId}`);
        if (el) {
          el.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      }, 100);
    }

    return Object.keys(newErrors).length === 0;
  };

  const moveUp = (qId, index) => {
    setQuestions(prev =>
      prev.map(q => {
        if (q.id !== qId) return q;

        const newItems = [...q.items];
        [newItems[index - 1], newItems[index]] =
          [newItems[index], newItems[index - 1]];

        return { ...q, items: newItems };
      })
    );
  };

  const moveDown = (qId, index) => {
    setQuestions(prev =>
      prev.map(q => {
        if (q.id !== qId) return q;

        const newItems = [...q.items];
        [newItems[index + 1], newItems[index]] =
          [newItems[index], newItems[index + 1]];

        return { ...q, items: newItems };
      })
    );
  };

  const [questions, setQuestions] = useState([

    {
      no: '1',
      id: '201',
      question: 'What is your age range?',
      type: 'radio',
      options: ['18-24', '25-29', '30-34', '35-39', '40-44', '45 and over']
    },
    {
      no: '2',
      id: '202',
      question: 'Which country are you located?',
      type: 'radio',
      options: [
        'Anguilla',
        'Guyana',
        'Antigua and Barbuda',
        'Haiti',
        'Aruba',
        'Jamaica',
        'Bahamas',
        'Saba',
        'Barbados',
        'Martinique',
        'Belize',
        'Montserrat',
        'Bermuda',
        'Saint Kitts and Nevis',
        'Bonaire',
        'Saint Lucia',
        'St. Eustatius',
        'Sint Maarten',
        'British Virgin Islands',
        'Saint Vincent and the Grenadines',
        'Cayman Islands',
        'Suriname',
        'Curacao',
        'Trinidad and Tobago',
        'Dominica',
        'Turks and Caicos',
        'Grenada',
        'Other'
      ],
      hasOther: true
    },
    {
      no: '3',
      id: '203',
      question: 'Type of Institution',
      type: 'radio',
      options: [
        'Academia',
        'Public Sector',
        'Private Sector',
        'Government',
        'Non-Governmental Organisation',
        'Inter-Governmental Organisation',
        'Civil Society Organisation',
        'Other'
      ],
      hasOther: true
    },
    {
      no: '4',
      id: '204',
      question: 'Do you operate (work/study) in a health-related field?',
      type: 'radio',
      options: ['Yes', 'No']
    },
    {
      no: '5',
      id: '205',
      question:
        'Please rate the following aspects of the Oral Presentation Sessions:',
      type: 'rating-matrix',
      items: [
        { id: '206', label: 'Scientific content' },
        { id: '207', label: 'Clarity of presentation' },
        { id: '208', label: 'Quality of slides' },
        { id: '209', label: 'Discussion' },
        { id: '210', label: 'Time management' }
      ],
      scale: ['Very Poor', 'Poor', 'Average', 'Good', 'Excellent']
    },
    {
      no: '6',
      id: '211',
      question: "Which session and/or oral presentation under 9a Infectious Diseases was the most outstanding?",
      type: 'radio',
      options: [
        "0-77: Implementation of the Caribbean regional field epidemiology and laboratory training programme, lessons learned 2014 - 2025.",
        "0-78: Knowledge, attitudes, practices and perceptions of the general population in Barbados regarding antimicrobial use in the food supply.",
        "0-79: Investigation of the frequency and antimicrobial resistance patterns of gram-negative infections in Barbados: a cross-sectional study.",
        "0-80: Microbial analysis of instant rice produced locally in Guyana.",
        '0-81: "Walking with the enemy": bacterial contamination of mobile phones among healthcare workers and mothers in a hospital neonatal care unit.',
        "Not applicable"
      ]
    },
    {
      no: '7',
      id: '212',
      question: "Which session and/or oral presentation under 9b: Non-communicable Diseases was the most outstanding?",
      type: 'radio',
      options: [
        "0-88: Early life social factors associated with mortality in Jamaicans with Sickle Cell Disease.",
        "0-89: The association between balance and falls and quality of life among the elderly with COPD: a case control study in Trinidad and Tobago.",
        "0-90: Differences in body and muscle composition by diabetes status among Tobagonian men: 6-year follow-up.",
        "0-91: The Tobago brain health study.",
        "0-92: The effects of metal mixtures on blood pressure and hypertension in adults from Tobago.",
        "Not applicable"
      ]
    },
    {
      no: '8',
      id: '213',
      question: "Which session and/or oral presentation under 10a: Infectious Diseases was the most outstanding?",
      type: 'radio',
      options: [
        "0-82: Epidemiology of human leptospirosis in Grenada, 2018-2025: a retrospective population-based study.",
        "0-83: Evidence of human, rodent, and rat hantavirus infections in Grenada.",
        "0-84: Diagnosis and epidemiology of arbovirus infections in Grenada 2023-2025.",
        "0-85: Comorbidities and mortality during the SARSCoV-2 outbreak in Grenada.",
        "0-86: An educational strategy to reduce HPV vaccine hesitancy among parents of adolescents from selected schools in Georgetown, Guyana: an experimental study",
        "0-87: Burden of acute gastroenteritis and foodborne pathogens in Trinidad and Tobago: evidence for policy and surveillance strengthening.",
        "Not applicable"
      ]
    },
    {
      no: '9',
      id: '214',
      question: "Which session and/or oral presentation under 10b. Non-communicable Diseases was the most outstanding?",
      type: 'radio',
      options: [
        "0-93: Cardiovascular disease risk prediction and cardiovascular mortality in Barbados.",
        "0-94: Barriers, facilitators, and perceived benefits of church-based gardening with kalinago community for non-communicable diseases: qualitative insights from a non-randomized implementation trial.",
        "0-95: Associates between neighborhood socioeconomic status and cardiovascular diseases in adults forty years and older in urban Jamaica.",
        "0-96: Health-Related quality of life after pacemaker implantation in Surinamese patients: a prospective cohort study",
        "0-97: Trends in hypertension prevalence, awareness, treatment and control in Jamaica.",
        "0-98: Assessing the prevalence of diabetes distress and associated factors in patients with type 2 diabetes at community clinics in New Providence, Bahamas.",
        "Not applicable"
      ]
    },
    {
      no: '10',
      id: '215',
      question: "Which session and/or oral presentation under 10c: Poster Session 5 was the most outstanding?",
      type: 'radio',
      options: [
        "P-61: Public Knowledge , attitudes and practices regarding antibiotic usage and resistance in Barbados.",
        "P-62: Patients' and healthcare workers' knowledge, attitudes and practices towards climate change in a Caribbean Small Islands Developing state.",
        "P-63: The perception of climate change and its impact on health among healthcare workers in Guyana.",
        "P-64: Assessing community awareness and attitudes about climate change in a well-child clinic in Guyana.",
        "P-65: Parental perception of climate change in a well-child clinic in Guyana.",
        "P-66: Impact of adverse childhood experiences on adult physical health.",
        "P-67: Sociodemographic and health characteristics of elderly people referred to public-long term healthcare facilities in Barbados.",
        "P-68: Case studies on prevention of mother-to-child transmission (PMTCT) on HIV in remote Guyanese communities: a close look at missed opportunities, social inequities, and clinical gaps in maternal HIV care.",
        "P-69: Perceptions of HIV, pre exposure prophylaxis (PrEP), and youth-friendly prevention services among undergraduate students in health-related programmes in Guyana.",
        "P-70: Two decades plus delivering private HIV care and treatment in a predominantly public sector developing country setting: The Guyana experience.",
        "P-71: From knowledge to practice: public understanding of dengue fever in a dengue-endemic country.",
        "P-72: First report of Mansonia indubitans in Guyana",
        "P-73: Innovations in arboviral diagnostics: implementation and impact of multiplex panel testing in Guyana, South America.",
        "P-74: HPV awareness in allied health professionals: evaluating the level of understanding and knowledge in Guyana.",
        "P-75: First report of Aedes albopictus in Guyana.",
        "P-76: Social drivers of health and their impact on work and income of adults in Antigua and Barbuda during COVID-19.",
        "P-77: First antimicrobial susceptibility profiling of Burkholderia pseudomallei clinical isolates in the Caribbean: public health significance and regional context.",
        "P-78: Unmasking the pathogen: a characterization of candida and other clinically relevant yeast in Barbados.",
        "Not applicable"
      ]
    },
    {
      no: '11',
      id: '216',
      question: "Which session and/or oral presentation under 11a: Public Health was the most outstanding?",
      type: 'radio',
      options: [
        "0-99: Household food self-production and diet, wellbeing, and hypertension in a small island developing state: a cross-sectional study.",
        "0-100: Voices from the counselling room: understanding burnout among school counsellors in Guyanese schools.",
        "0-101: Patient experiences with primary health care services in Grenada: a national cross-sectional study.",
        "0-102: Clinical presentation and laboratory findings of children with dengue in Guyana during the outbreak 2024-2025.",
        "0-103: Physician training at the University of Guyana School of Medicine (UGSM) and its contribution to he transformation of the country's health care sector.",
        "0-104: One-Stop-Shop imaging for cancer diagnosis in the Caribbean: an integrated PET-CT and PET-MRI approach.",
        "0-105: Ambient particulate matter ratio as an indicator of Saharan dust intrusion: a pilot study in Grenada.",
        "0-106: Enhancing Real-life Data in Insular Territories.",
        "0-107: International organizations' influence on health and safety in Guyana's oil & gas industry.",
        "0-108: A study assessing the predictive utility of triglycerides and total cholesterol in identifying cardiovascular disease risk among adult patients attending Mahaicony District Hospital, Guyana.",
        "Not applicable"
      ]
    },
    {
      no: '12',
      id: '217',
      question: "Which session and/or oral presentation under 11b: Non-communicable Diseases was the most outstanding?",
      type: 'radio',
      options: [
        "0-109: A qualitative study on the role of psychosocial support in managing the needs of adolescents living with type 1 diabetes mellitus between 10 and 19 years old from the adolescent's perspective.",
        "0-110: Innovating health promotion in the Caribbean: a multisectoral, whole-of-society approach to the Caribbean moves initiative.",
        "0-111: Impact of excessive carotid tortuosities on mechanical thrombectomy in French West Indies.",
        "0-112: Prevalence and symptomatology of attention-deficit/hyperactivity disorder among undergraduate students at the University of the West Indies, St. Augustine: a cross-sectional descriptive study.",
        "0:113: Harnessing pre-existing data for public health research in the Caribbean: The CHLOECAPA Experience on prostate cancer and environmental exposure.",
        "0-114: Safety and efficacy of using combined interferons alpha 2b and gamma for treatment of basal cell carcinoma at a Clinical Surgical Hospital Salvador Allende Havana, Cuba.",
        "0-115: Development of a Cancer dashboard for cancer registries in the English-speaking Caribbean region: an example of Barbados National Registry Cancer Dashboard.",
        "0-116: The 'Stage Shift' effect: evaluating the impact of decentralized PSA screening on downward stage migration of prostate cancer in Guyana (2024-2025)",
        "0-117: Perceptions and barriers to prostate cancer screening among Guyanese men.",
        "0-118: The prevalence of metabolic syndrome and iron-deficiency anemia in patients with localized prostate cancer.",
        "Not applicable"
      ]
    },



    {
      no: '13',
      id: '218',
      question: 'Please rate the following aspects of the Poster Presentations',
      type: 'rating-matrix',
      items: [
        { id: '219', label: 'Scientific content' },
        {
          id: '220',
          label: 'Clarity of presentation [if video was viewed/accessible]'
        },
        { id: '221', label: 'Visual impact' }
      ],
      scale: ['Very Poor', 'Poor', 'Average', 'Good', 'Excellent']
    },
    {
      no: '14',
      id: '222',
      question:
        'Please select a rating for the following aspects of the event facilities:',
      type: 'rating-matrix',
      items: [
        { id: '223', label: 'Secretariat support' },
        {
          id: '224',
          label:
            'Physical venue: ease of accessing location and organization of lecture & session rooms'
        },
        {
          id: '225',
          label:
            'Engagement at Location: discussions with presenters/exhibitors and other attendees'
        },
        {
          id: '226',
          label: 'Display and presentation of Exhibition Booths at the location'
        },
        { id: '227', label: 'Technical support for participants on location' },
        { id: '228', label: 'Selection and Quality of Food' }
      ],
      scale: ['Very Poor', 'Poor', 'Average', 'Good', 'Excellent']
    },
    {
        no: "15",
        id: "229",
        question: "What were your expectations/goals for attending this Conference? Please rank options below, with 1 as the highest goal and 6 as the lowest?",
        type: "ranking",
        items: [
          { id: "230", label: "Gaining more subject matter expertise or expanding your knowledge and find solutions to problems" },
          { id: "231", label: "Network for future collaborations" },
          { id: "232", label: "Peer discussion of new research for application" },
          { id: "233", label: "To find about out more about public health in the Caribbean region" },
          { id: "234", label: "Improve research skills set" },
          { id: "235", label: "Presentation of a research paper" }
        ],
        originalItems: [
            { id: "230" },
            { id: "231" },
            { id: "232" },
            { id: "233" },
            { id: "234" },
            { id: "235" }
          ]
      },
    {
      no: '16',
      id: '236',
      question:
        'Where there any standout moments or experiences during the conference?',
      type: 'textarea'
    },
    {
      no: '17',
      id: '237',
      question:
        'On a scale of 1 to 10, how likely are you to recommend the CARPHA Conference to a friend or colleague?',
      type: 'rating',
      scale: 10
    },
    {
      no: '18',
      id: '238',
      question: 'Did you attend the Awards Ceremony?',
      type: 'radio',
      options: ['Yes', 'No']
    },
    {
      no: '19',
      id: '239',
      question: 'Please select a rating for the following aspects of the Awards Ceremony:',
      type: 'rating-matrix',
      items: [
        { id: '240', label: 'Programming' },
        {
          id: '241',
          label: 'Distinguished Speakers'
        },
        { id: '242', label: 'Venue' },
        { id: '243', label: 'Entertainment' },
        { id: '244', label: 'Selection and Quality of Food' }
      ],
      scale: ['Very Poor', 'Poor', 'Average', 'Good', 'Excellent']
    },

    {
      no: '20',
      id: '245',
      question:
        'Please state below any general comments or suggestions for improvement in the future.',
      type: 'textarea'
    },
    {
      no: '21',
      id: '246',
      question: 'CME Credits - Day 3 Only (April 24, 2026) - 7.50 Credits',
      type: 'radio',
      options: ['Confirm Credits', 'Does Not Apply']
    }

  ]);

  const handleChange = (id, value) => {
    setAnswers(prev => ({
      ...prev,
      [id]: value
    }));

    // 🔥 HAPUS ERROR SAAT USER ISI
    setErrors(prev => {
      const newErrors = { ...prev };
      delete newErrors[id];
      return newErrors;
    });
  };

  const handleSubmit = () => {
    if (!validate()) {
        alert("Please complete all questions first");
        return;
      }

      let survey = [];

      // 🔹 normal answers
      Object.keys(answers).forEach(key => {
        survey.push({
          id_question: key,
          answer: answers[key]
        });
      });

      // 🔥 ranking answers (INI YANG KAMU MAU)
      questions.forEach(q => {
        if (q.type === "ranking") {
            q.items.forEach((item, index) => {
                survey.push({
                  id_question: q.originalItems[index].id, // 🔥 ID tetap
                  answer: item.label                      // 🔥 label geser
                });
              });
        }
      });



    const payload = {
      id_user: props?.user?.id_user,
      day: 3,
      json: JSON.stringify({
        survey : survey
      })
    };


      var form_data = new FormData();

      for (var key in payload) {
        form_data.append(key, payload[key]);
      }

      setLoading(true);
      setMsgerror("");

      axios
        .post(CONFIG.URL + '/survey/submit', form_data, {
          headers: {
            token: CONFIG.TOKEN_SURVEY
          }
        })
        .then(function (response) {
          setLoading(false);
          if (response?.data?.status === 'SUCCESS') {
props.onSuccess()
          } else {
          }
        })
        .catch(function (error) {});

  };

  return (
    <div className="w-full mx-auto space-y-2">

      <div className="w-full bg-white">
      <hr className='my-2'/>
      <div className="text-black flex flex-col font-bold my-2 text-2xl text-center">
                <span className="text-4xl"> {props?.user?.name}</span>
                <span className="text-lg text-black mt-2">
                  {props?.user?.position}
                </span>
                <span className="text-lg text-black mt-2">{props?.user?.company}</span>

              </div>

              <hr className='my-2'/>
        {/* TOP TITLE BAR */}
        <div className="bg-slate-600 text-white text-center py-6 px-4">
          <h1 className="text-xl md:text-2xl font-bold tracking-wide">
            CARPHA 70TH ANNUAL HEALTH RESEARCH CONFERENCE
          </h1>
          <p className="text-lg md:text-xl font-semibold mt-1">
            EVALUATION FORM – Day 3
          </p>
        </div>

        {/* CONTENT */}
        <div className="max-w-4xl mx-auto px-6 py-8 space-y-6">
          <h2 className="text-xl font-bold">
            Welcome to the CARPHA 70TH Annual Health Research Conference
            Evaluation
          </h2>

          <p className="text-gray-700 leading-relaxed">
            Please share your conference experience by completing this survey.
            Your feedback is important to assist with improving our Annual
            Health Research Conference. All your responses are anonymous and
            confidential as CARPHA would not be collecting any personal
            information. If you click the survey link, you are stating that you
            understand that your participation in this survey is completely
            voluntary.
          </p>
        </div>
      </div>

      {questions.map((q) => {
        const hasMatrixError =
        q.type === "rating-matrix" &&
        q.items.some(item => errors[item.id]);

        return ( <div
          id={`question-${q.id}`}
            key={q.id}
             className={`p-4 border rounded-xl shadow-sm ${
        errors[q.id] || hasMatrixError
          ? "border-red-500"
          : "border-gray-200"
      }`}>
            <p className="font-semibold mb-3">
              {q.no}. {q.question}
            </p>

            {/* RADIO */}
            {q.type === 'radio' && (
              <div className="flex flex-wrap gap-2">
                {q.options.map((opt) => {
                  const isSelected = answers[q.id] === opt;

                  return (
                    <button
                      key={opt}
                      type="button"
                      onClick={() => handleChange(q.id, opt)}
                      className={`
              px-4 py-2 rounded-lg border text-sm transition text-left
              ${
                isSelected
                  ? 'bg-blue-600 text-white border-blue-600'
                  : 'bg-white hover:bg-blue-50 border-gray-300'
              }
            `}>
                      {opt}
                    </button>
                  );
                })}

                {/* OTHER INPUT */}
                {q.hasOther && (
                  <input
                    type="text"
                    placeholder="Other..."
                    className="w-full border p-2 rounded mt-2"
                    onChange={(e) => handleChange(q.id, e.target.value)}
                  />
                )}
              </div>
            )}

{q.type === "ranking" && (
  <div className="space-y-2">
    {q.items.map((item, index) => (
      <div
        key={item.id}
        className="flex items-center justify-between border p-2 rounded"
      >
        <span className="text-sm">
          {index + 1}. {item.label}
        </span>

        <div className="flex gap-2">
          <button
            type="button"
            disabled={index === 0}
            onClick={() => moveUp(q.id, index)}
            className="px-2 border rounded"
          >
            ↑
          </button>

          <button
            type="button"
            disabled={index === q.items.length - 1}
            onClick={() => moveDown(q.id, index)}
            className="px-2 border rounded"
          >
            ↓
          </button>
        </div>
      </div>
    ))}
  </div>
)}

            {/* TEXTAREA */}
            {q.type === 'textarea' && (
              <textarea
                className="w-full border p-2 rounded"
                rows="3"
                onChange={(e) => handleChange(q.id, e.target.value)}
              />
            )}

            {/* RATING 1-10 */}
            {q.type === 'rating' && (
              <div className="space-y-2">
                {/* Label kiri kanan */}
                <div className="flex justify-between text-xs text-gray-500">
                  <span>Not at all likely</span>
                  <span>Extremely likely</span>
                </div>

                {/* Button rating */}
                <div className="flex w-full gap-2">
                  {Array.from({ length: q.scale }, (_, i) => i + 1).map((num) => {
                    const isActive = answers[q.id] === num;

                    return (
                      <button
                        key={num}
                        type="button"
                        onClick={() => handleChange(q.id, num)}
                        className={`
                 h-10 rounded-lg border text-sm font-medium w-full
                transition-all duration-150
                ${
                  isActive
                    ? 'bg-blue-600 text-white border-blue-600 scale-110 shadow'
                    : 'bg-white border-gray-300 hover:bg-blue-50'
                }
              `}>
                        {num}
                      </button>
                    );
                  })}
                </div>
              </div>
            )}

            {q.type === 'rating-matrix' && (
              <div className="space-y-4">
                {q.items.map((item) => {
                  const selected = answers[item.id];

                  return (
                    <div id={`question-${item.id}`} key={item.id}>
                      <p className="text-sm font-medium mb-2">{item.label}</p>

                      <div className="flex w-full gap-2">
                        {q.scale.map((scale) => {
                          const isActive = selected === scale;

                          return (
                            <button
                              key={scale}
                              type="button"
                              onClick={() => handleChange(item.id, scale)}
                              className={`w-full
                      px-3 py-1.5 text-xs rounded-lg border transition
                      ${
                        isActive
                          ? 'bg-blue-600 text-white border-blue-600'
                          : 'bg-white border-gray-300 hover:bg-blue-50'
                      }
                    `}>
                              {scale}
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

{(errors[q.id] || hasMatrixError) && (
  <p className="text-red-500 text-sm mt-2">
   This field is required
  </p>
)}
          </div>)
      }



      )


      }

{msgerror !== '' && (
                <div className="w-full max-w-lg text-center py-2 px-2 rounded-md my-2  text-red-500 font-bold">
                  {msgerror}
                </div>
              )}

      <div className='flex w-full gap-4'>
        <button
          onClick={() => props.handleCancel()}
          className="bg-red-600 text-white px-4 py-2 rounded w-max">
          Cancel
        </button>
        <button
        disabled={loading}
        onClick={handleSubmit}
        className="bg-blue-600 text-white px-4 py-2 rounded w-full">
        {loading ? "Submitting..." : "Submit Survey"}
      </button>
      </div>


    </div>
  );
}
